var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { call, put, takeEvery } from "redux-saga/effects";
import { fetchRatesByOrderFailure, FETCH_RATES_BY_ORDER_REQUEST, fetchRatesByOrderSuccess } from "../../actions";
import APIIN from "@/utils/APIIN";
const fetchCarrierRatesByOrder = (action) => __awaiter(void 0, void 0, void 0, function* () {
    return yield new Promise((resolve, reject) => __awaiter(void 0, void 0, void 0, function* () {
        try {
            APIIN.get("/cnvt/rates?orders=" + action.payload)
                .then((response) => {
                resolve(response);
            })
                .catch((error) => {
                reject(error);
            });
        }
        catch (error) {
            if (error instanceof Error) {
                reject(error);
            }
        }
    }));
});
function* fetchCarrierRatesByOrderDataWorker(action) {
    try {
        const data = yield call(fetchCarrierRatesByOrder, action);
        yield put(fetchRatesByOrderSuccess(data));
    }
    catch (error) {
        yield put(fetchRatesByOrderFailure(error));
    }
}
export function* watchFetchRatesByOrderData() {
    yield takeEvery(FETCH_RATES_BY_ORDER_REQUEST, fetchCarrierRatesByOrderDataWorker);
}
